import { createSlice } from '@reduxjs/toolkit';

export const WagonResearchSlice = createSlice({
  name: 'wagonResearch',
  initialState: {
    wagonNumber: '',
    selectedTab: 'wagonDetails',
    wagonDetails: {},
    ticketsHistoric: [],
    rowsFilters: [],
    sortConfig: [],
  },
  reducers: {
    setWagonNumberResearched: (state, action) => {
      state.wagonNumber = action.payload;
    },
    setWagonDetails: (state, action) => {
      state.wagonDetails = action.payload;
    },
    setTicketsHistoric: (state, action) => {
      state.ticketsHistoric = action.payload;
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setRowsFiltersForTicketHistoric: (state, action) => {
      const list = state.rowsFilters.filter(
        (item) => item.cell === action.payload.cell,
      );
      if (list.length > 0) {
        state.rowsFilters = state.rowsFilters.filter(
          (item) => item !== list[0],
        );
      }
      state.rowsFilters.push(action.payload);
    },
    initializeRowsFiltersForTicketHistoric: (state) => {
      state.rowsFilters = [];
    },
    setSortConfigForTicketHistoric: (state, action) => {
      state.sortConfig = action.payload;
    },
  },
});
export const {
  setWagonNumberResearched,
  setWagonDetails,
  setSelectedTab,
  setTicketsHistoric,
  setRowsFiltersForTicketHistoric,
  setSortConfigForTicketHistoric,
  initializeRowsFiltersForTicketHistoric,
} = WagonResearchSlice.actions;

export const wagonNumberState = (state) => state.wagonResearch.wagonNumber;
export const selectedTabState = (state) => state.wagonResearch.selectedTab;
export const wagonDetailsState = (state) => state.wagonResearch.wagonDetails;
export const ticketsHistoricState = (state) =>
  state.wagonResearch.ticketsHistoric;
export const rowsFiltersForTicketHistoricState = (state) =>
  state.wagonResearch.rowsFilters;
export const sortConfigState = (state) => state.wagonResearch.sortConfig;

export default WagonResearchSlice.reducer;
